import * as React from "react";
function SvgShare(props, svgRef) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={svgRef}
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M18 8a2 2 0 100-4 2 2 0 000 4zm0 2a4 4 0 10-3.892-3.07L9.27 9.694a4 4 0 10-.252 4.932l5.07 2.535a4 4 0 10.895-1.788l-5.07-2.536a4.016 4.016 0 00.067-1.246l5.067-2.895A3.99 3.99 0 0018 10zm0 10a2 2 0 100-4 2 2 0 000 4zM8 12a2 2 0 11-4 0 2 2 0 014 0z"
                fill="currentcolor"
            />
        </svg>
    );
}
const ForwardRef = React.forwardRef(SvgShare);
export default ForwardRef;
